import './App.css';
import UseForm from './components/UseForm';

function App() {
  return (
    <div className="App">
      <UseForm />
    </div>
  );
}

export default App;
